import { collection } from "firebase/firestore";
import { db } from "./firebase";

export const roles = collection(db, "roles");
